// extracted by mini-css-extract-plugin
export default {"button":"LogoutButton_button__Vi59C"};